<nav class="navbar navbar-expand-lg bg-light sticky-top" v-if="$isMobile()">
  <div class="container-fluid" style="flex-flow: row wrap; align-items: center">
    <router-link class="navbar-brand" :to="'/'">
      <img class="logomobile" src="/logo-togamas.png" alt="" />
    </router-link>

    <div class="submenumobile">
      <router-link
        to="/event"
        class="nav-link text-success"
        aria-current="page"
      >
        <i class="ri-calendar-event-line"></i>
      </router-link>

      <router-link class="nav-link text-success" to="/voucher">
        <i class="ri-coupon-2-line"></i>
      </router-link>

      <router-link class="nav-link text-success" to="/cart">
        <i class="ri-shopping-cart-line"></i>
        <span class="cartqty">1</span>
      </router-link>

      <router-link
        class="nav-link text-success"
        to="/signin"
        v-if="!this.$store.state.user"
      >
        <i class="ri-login-box-line"></i>
      </router-link>
      <router-link class="nav-link text-success" to="/profile" v-else>
        <i class="ri-user-line"></i>
      </router-link>
    </div>

    <!-- <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarScroll"
      aria-controls="navbarScroll"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <i class="ri-menu-line"></i>
    </button> -->

    <div class="d-block" role="search" style="width: 100%">
      <input
        class="form-control mt-3 mb-2 searchmobile"
        type="search"
        placeholder="Cari Buku Apa Hari ini?"
        aria-label="Search"
        v-model="keyword"
        @keyup.enter="searchProduct"
      />

      <!-- <button
        class="btn btn-outline-success"
        type="button"
        @click="searchProduct"
      >
        Search
      </button> -->
    </div>

    <div class="collapse navbar-collapse" id="navbarScroll">
      <div class="row">
        <div class="col">
          <ul class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll">
            <li class="nav-item"></li>
            <li class="nav-item"></li>
          </ul>
        </div>
        <div class="col">
          <ul class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll">
            <li class="nav-item"></li>
            <li class="nav-item" v-if="!this.$store.state.user">
              <router-link class="nav-link text-success" to="/signin">
                <i class="ri-login-box-line"></i>
                Masuk</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link text-success"
                to="/signup"
                v-if="!this.$store.state.user"
              >
                <i class="ri-user-add-line"></i>
                Daftar</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link text-success"
                to="/profile"
                v-if="this.$store.state.user"
              >
                <i class="ri-user-line"></i>
                Profile</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>

<header class="menu-navbar">
  <div class="container">
    <div class="row menu-content" v-if="!$isMobile()">
      <div class="navbar-logo col-lg-2 col-2">
        <router-link to="/" title="Togamas.com">
          <img class="logopc" src="/logo-togamas.png" alt="" />
          <img class="logomobile" src="/togamas-mobile.png" alt="" />
        </router-link>
      </div>
      <div class="search-area col-lg-5 col-9">
        <input
          type="text"
          placeholder="Mau cari buku apa hari ini?"
          v-model="keyword"
          @keyup.enter="searchProduct"
        />
      </div>
      <div class="navigation-area col-lg-4 col-1">
        <router-link to="/event" class="cart-button">
          <i class="ri-calendar-event-line"></i>
        </router-link>
        <router-link to="/voucher" class="cart-button">
          <i class="ri-coupon-2-line"></i>
        </router-link>
        <button type="button" @click="goToCart()" class="cart-button">
          <i class="ri-shopping-cart-line"></i>
          <span
            class="cartqty"
            v-if="$store.state.cart_count > 0 && $store.state.user"
            >{{ $store.state.cart_count > 99 ? "99+" : $store.state.cart_count
            }}</span
          >
        </button>
        <router-link
          to="/signin"
          style="margin-right: 10px"
          v-if="!this.$store.state.user"
          ><button class="btn btn-success masuk">Masuk</button>
        </router-link>
        <router-link
          to="/profile"
          class="btn-style-one btn d-none d-lg-flex"
          style="margin-right: 10px"
          v-if="this.$store.state.user"
        >
          Profile
        </router-link>
        <router-link to="/signup" v-if="!this.$store.state.user"
          ><button class="btn btn-outline-success">Daftar</button>
        </router-link>
      </div>
    </div>
    <div class="mini-navbar">
      <ul>
        <template v-if="subCategories.length > 0">
          <template
            v-if="!loading.subCategories"
            v-for="(subCategory, index) in subCategories.length == 8 ? subCategories : subCategories.slice(0,7)"
          >
            <li>
              <router-link :to="'/product?sub_category_id=' + subCategory.id">
                {{ subCategory.name }}
              </router-link>
            </li>
          </template>
          <li v-if="subCategories.length > 8">
            <div class="dropdown">
              <button
                class="dropdown-toggle"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style="color: #343a40"
              >
                Lainnya
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link
                  v-for="(subCategory) in subCategories.slice(7)"
                  :to="'/product?sub_category_id='+ subCategory.id"
                  class="dropdown-item"
                  >{{ subCategory.name }}</router-link
                >
              </div>
            </div>
          </li>
        </template>
        <li v-if="loading.subCategories">
          <span class="span-skeleton" v-for="i in 8">
            <PuSkeleton height="18px" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</header>
